import posthog from 'posthog-js';
import { IUser, type WorkspaceUser } from 'src/@types/user';
import type { LocationData } from 'src/state';

type Actions = {
  // auth
  guest_login: undefined;
  guest_logout: undefined;
  user_logout: undefined;
  user_login: undefined;
  user_register: {
    source?: 'invite';
  };

  workspace_invite:
    | {
        method: 'link';
      }
    | {
        method: 'email';
        sentInvites: number;
      };
  workspace_join: undefined;
};

export function capture<E extends keyof Actions>(name: E, data?: Actions[E]) {
  posthog.capture(name, data);
}

export function identity(user: IUser) {
  posthog.identify(user._id, { name: user.name, email: user.email });
}

export function identifySession(user: IUser, session: LocationData) {
  posthog.identify(user._id, {
    workspace_slug: session.workspaceSlug,
    workspace_id: session.workspaceId,
  });
}

export const identifyGatheringSpaceGuest = (user: WorkspaceUser) => {
  posthog.identify(user._id, {
    name: user.name,
    email: user.email,
    isGatheringSpaceGuest: true,
    ...(user.workspace && {
      workspace_slug: user.workspace.slug,
      workspace_id: user.workspace._id,
    }),
  });
};

export function timing<E extends keyof Actions>(name: E, data?: Actions[E]) {
  posthog.capture(`start_${name}`, data);

  return () => {
    posthog.capture(`end_${name}`, data);
  };
}

export function getRecordURL() {
  return posthog.get_session_replay_url({
    timestampLookBack: 15,
    withTimestamp: true,
  });
}
